import { Controller } from 'react-hook-form';
import { Info } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import { theme } from '@myme/utils';
import { usePalette } from 'src/hooks';
import { TextField, Typography } from 'src/components/atoms';
import { Flex } from 'src/components/layout';
import { FormFieldContainer, FormFieldProps } from './utils';

export const FormField = ({
  control,
  name,
  inputProps,
  defaultValue,
  rules,
  isError,
  errorMsg,
  helperMessage,
  containerStyle
}: FormFieldProps & { containerStyle?: React.CSSProperties }) => {
  const { error } = usePalette();

  return (
    <Flex justifyContent='space-around' alignItems='center' style={containerStyle}>
      <FormFieldContainer>
        <Controller
          render={({ field: { ref, ...field } }) => <TextField {...inputProps} {...field} inputRef={ref} />}
          name={name}
          defaultValue={defaultValue || ''}
          control={control}
          rules={rules}
        />
        {isError && (
          <Typography variant='body2' color={error.main} sx={{ ml: 2, mb: 1, mt: 1 }}>
            {errorMsg}
          </Typography>
        )}
      </FormFieldContainer>
      {helperMessage && (
        <Tooltip title={helperMessage} style={{ marginInline: '0.5rem', marginBottom: isError ? '2rem' : '1rem' }}>
          <IconButton>
            <Info style={{ color: theme.colors.white }} />
          </IconButton>
        </Tooltip>
      )}
    </Flex>
  );
};
